
// Default value to send to Teller to get default color scheme
export const DEFAULT_THEME_SUBDOMAIN = 'UNBRANDED';
